import Dropdown from "rc-dropdown";
import React, { useEffect, useState } from "react";
import { DelayInput } from "react-delay-input/lib/Component";
import {
  StyledFilterBlock, StyledFilterBlockTitle, StyledFilterCloseBtn,
  StyledFilterDropdownWrapper,
  StyledFilterGroup, StyledFilterWrapper, StyledShowFilterBtn
} from "../../../elements/filter/styledFiter";
import ServicesSelect from "../../../elements/services/ServicesSelect";
import DefaultButton from "../../../styles/materialButtonStyle";

const ServiceExclusionFilter = ({ filterData, setFilterData, t }) => {
  const DEFAULT_FILTER_DATA = {
    "page": 1,
    "currentTab": filterData["currentTab"],
    "name": null,
    "value": null,
    "service.name": null,
    "itemsPerPage": filterData["itemsPerPage"] ?? null
  };

  const [visible, setVisible] = useState(false);

  const onVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleClearFilter = () => {
    setFilterData(DEFAULT_FILTER_DATA);
  };

  const FilterList = () => {
    return (
      <>
        {visible &&
          <StyledFilterDropdownWrapper>
            <StyledFilterBlock actions>
              <StyledFilterGroup className="clear-btn">
                <DefaultButton
                  color="transparent"
                  onClick={handleClearFilter}
                >
                  {t("filter.clearBtn")}
                </DefaultButton>
              </StyledFilterGroup>
              <StyledFilterGroup className="close-btn">
                <StyledFilterCloseBtn onClick={() => setVisible(false)} />
              </StyledFilterGroup>
            </StyledFilterBlock>
            <StyledFilterBlockTitle>
              {t("filter.filterBy")}:
            </StyledFilterBlockTitle>
            <StyledFilterBlock col="2">
              <StyledFilterGroup>
                <label htmlFor="bin">
                  {t("exclusions.table.name")}
                </label>
                <DelayInput
                  id="bin"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "name": event.target.value, page: 1 })}
                  name="name"
                  value={filterData["name"]}
                  type="text"
                />
              </StyledFilterGroup>
              <StyledFilterGroup>
                <label htmlFor="country">
                  {t("exclusions.table.value")}
                </label>
                <DelayInput
                  id="value"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "value": event.target.value, page: 1 })}
                  name="value"
                  value={filterData["value"]}
                  type="text"
                />
              </StyledFilterGroup>
              <StyledFilterGroup>
                <ServicesSelect
                  checkedService={filterData["service.name"]}
                  setCheckedService={(data) => setFilterData({
                    ...filterData,
                    "service.name": data,
                    page: 1
                  })}
                  isObject={false}
                  defaultOption={true}
                />
              </StyledFilterGroup>
            </StyledFilterBlock>
          </StyledFilterDropdownWrapper>}
      </>
    );
  };

  return (
    <StyledFilterWrapper id="filter">
      <Dropdown
        getPopupContainer={() => document.getElementById("filter")}
        overlay={FilterList}
        trigger={["click"]}
        placement="bottomLeft"
        onVisibleChange={onVisibleChange}
        visible={visible}
        closeOnSelect={false}
      >
        <StyledShowFilterBtn>
          <DefaultButton
            color="success"
          >
            {t("filter.filterBtn")}
          </DefaultButton>
        </StyledShowFilterBtn>
      </Dropdown>
    </StyledFilterWrapper>
  );
};

export default ServiceExclusionFilter;